<template>
  <div>
    <div
      style="padding: 5px 10px;
        background: white;
        display: flex;
        margin-bottom: 10px;
        box-shadow: 0 0 5px rgb(0 0 0 / 20%);
        align-items: center;"
    >
      <img src="/imgs/logorb.png" style="height:60px;" />
      <v-spacer></v-spacer>
      <v-btn color="primary" style="margin-right:10px;" @click="Login">
        <v-icon left>mdi-home-import-outline</v-icon>
        MASUK
      </v-btn>
    </div>
    <Grid
      id="table-kontrak"
      :datagrid.sync="datagrid"
      dbref="API.SelKontrakList"
      :dbparams.sync="filters"
      class="dense"
      style="padding:10px"
      :preHead="true"
      :disabled="true"
      :height="'calc(100vh - 100px)'"
      :doRebind="gridRebind"
      :hasChild="true"
      :columns="[
        {
          name: 'Paket',
          value: 'NamaPaket',
        },
        {
          name: 'Kontrak',
          value: 'Kontraktor',
          width: '200px',
        },
        {
          name: 'Progress',
          value: 'Progress',
          class: 'center',
        },
      ]"
    >
      <template v-slot:pre-head>
        <div style="display:flex;" class="pre-head">
          <div style="flex:2; font-size: 14px;">
            <Select
              dbref="API.SelBalai"
              width="500px"
              :value.sync="filters.BalaiID"
              @change="gridRebind++"
            />
          </div>
          <v-spacer></v-spacer>
        </div>
      </template>
      <template v-slot:child>
        <div
          style="background: #f3f3f3; box-shadow: inset 0 0 5px rgb(0 0 0 / 30%); "
        >
          <div
            v-if="!childData.length"
            style="width: 100%; padding:6px 10px; text-align:center"
          >
            Tidak Ada Data
          </div>
          <div
            v-else
            style="display:flex"
            v-for="(c, idx) in childData"
            :key="idx"
          >
            <div style="padding:6px 10px; width:280px;"></div>
            <div style="padding:6px 10px; width:210px; font-weight:bold;">
              {{ c.TerminDesc }}
            </div>
            <div style="padding:6px 10px; width:116px; text-align:center;">
              {{ c.TglSelesai | format }}
            </div>
            <div
              style="padding:6px 10px; width:135px; text-align:right;  font-weight:500;"
            >
              {{ c.NilaiTermin | format }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:row-NamaPaket="{ row }">
        <div
          style="width:550px; white-space: initial; font-weight:bold; color:#555"
        >
          {{ row.NamaPaket }}
        </div>
      </template>
      <template v-slot:row-Kontraktor="{ row }">
        <div style="font-weight:500;">{{ row.NoKontrak }}</div>
        <div style="width:190px; overflow: hidden; white-space:nowrap">
          {{ row.NamaKontraktor }}
        </div>
      </template>
      <template v-slot:row-Progress="{ row }">
        <div>{{ row.Progress }} %</div>
      </template>
    </Grid>
  </div>
</template>
<script>
export default {
  data: () => ({
    datagrid: [],
    gridRebind: 1,
    childData: [],
    sp2d: {},
    filters: {
      BalaiID: 0,
      Tahun: new Date().getFullYear(),
    },
    kontrakId: 0,
    showKontrakDet: false,
    showUploadDoc: false,
    showSP2D: false,
  }),
  methods: {
    Login() {
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>
<style lang="scss"></style>
